import { Component } from '@angular/core';
import { NavigationRoutes } from 'app/core/navigation';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class AppFooterComponent {

  links = [
    { link: ['/' + NavigationRoutes.ContactUsRoute], key: 'contactUs' },
    { link: ['/' + NavigationRoutes.ConfidentialityAgreementRoute], key: 'confidentialityAgreement' },
    { link: ['/' + NavigationRoutes.TermsOfUseRoute], key: 'termsOfUse' },
  ];

  param = { year: new Date().getFullYear() };

}
